import { downloadBlob } from '@risksmart-app/components/src/file/fileUtils';
import { useNotifications } from '@risksmart-app/components/src/notifications/useNotifications';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Link from '@/components/link';
import { useGetDataImportTemplate } from '@/hooks/queries/data-import/useGetDataImportTemplate';

type Props = {
  csvFile: string;
};

const TemplateLink: FC<Props> = ({ csvFile }) => {
  const getTemplate = useGetDataImportTemplate();
  const csvType = csvFile.replace('.csv', '');
  const { addNotification } = useNotifications();
  const { t } = useTranslation(['common'], { keyPrefix: 'dataImport' });

  return (
    <div data-testid={csvType}>
      <Link
        href={'#'}
        onFollow={async () => {
          try {
            downloadBlob(csvFile, await getTemplate(csvFile));
          } catch {
            addNotification({
              type: 'error',
              content: t('downloadTemplateFailedMessage'),
            });
          }
        }}
      >
        {t('downloadTemplate', { item: csvFile })}
      </Link>
    </div>
  );
};

export default TemplateLink;
